import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import {ReactBaseComponent} from '../../../../react/base/react-base.component';
import {FetchPositionFreezeForm} from '../../../../react/fetch/position/freeze-form/fetch-position-freeze-form';
import {FetchPositionClean} from './fetch-box.model';

const containerElementName = 'reactEvDatepicker';

@Component({
  selector: 'fetch-box-position-freeze-form',
  template: `<div class="inline-block" #${containerElementName}></div>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FetchBoxPositionFreezeFormReact extends ReactBaseComponent {
  @ViewChild(containerElementName, {static: false}) containerRef: ElementRef;
  @Input() position: FetchPositionClean;
  @Input() fetchStatus: number;
  @Input() hasTaskChangeGoldRight: boolean;
  @Output() reloadFetches: EventEmitter<void> = new EventEmitter<void>();

  constructor(private ngZone: NgZone) {
    super();
  }

  update(): void {
    this.ngZone.run(() => {
      this.reloadFetches.emit();
    });
  }

  protected renderComponent() {
    return <FetchPositionFreezeForm key={this.position.id}
                                    position={this.position}
                                    fetchStatus={this.fetchStatus}
                                    hasTaskChangeGoldRight={this.hasTaskChangeGoldRight}
                                    update={() => this.update()}/>;
  }
}
